import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { unregister } from './serviceWorkerRegistration';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, background: '#006064', color: '#fff', fontFamily: 'sans-serif', textAlign: 'center', padding: 24 }}>
          <div style={{ fontSize: 48 }}>🦀</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>Something went wrong.</div>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '12px 28px', borderRadius: 50, border: 'none', background: '#FF8A71', color: '#002D2F', fontWeight: 800, fontSize: 15, cursor: 'pointer' }}
          >
            Reload Kani Do
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Service worker disabled: it was serving stale cached bundles, so app
// updates never reached users. unregister() also removes any SW already
// installed on a returning visitor, clearing the stale cache for them.
unregister();
